import { Theme } from '@mui/material/styles'

const useStyles = {
  errorText: (theme: Theme) => ({
    marginTop: '-7px',
    color: theme.palette.error.main,
  }),
}
export default useStyles
